// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"0163f4b0","239":"216b0ef7"}[chunkId] + ".chunk.js";
};